import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { RootState } from "store";
import { BASE_BFF_WEB_URL } from "utilities/Constant";

export const logOutApi = createApi({
  reducerPath: "logOutApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_BFF_WEB_URL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const token = state.auth.accessToken;
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (build) => ({
    postLogout: build.mutation<void, void>({
      query: () => ({
        url: "Account/logout",
        method: "POST",
      }),
    }),
    postSessionInactvityLogout: build.mutation<void, string>({
      query: (userId) => ({
        url: `CyberSecurityAudit/user/${userId}/session-inactivity`,
        method: "POST",
      }),
    }),
  }),
});

export const { usePostLogoutMutation } = logOutApi;
